import React, {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {startLootboxAnimation} from 'util/animationUtils';
import ItemIcon from 'components/items/ItemIcon';
import {MarketContext} from 'util/market/MarketContext';

const LootboxRow = ({lootboxContent, onRowAnimationEnd, onSkippableChange}) => {
    const {allItems} = useContext(MarketContext);

    const [visibleItems, setVisibleItems] = useState([]);
    const [hiddenIndices, setHiddenIndices] = useState([]);
    const navigate = useNavigate();
    const [animationEnded, setAnimationEnded] = useState(false);

    const animationCleanupRef = useRef(null);

    const onAnimationEnd = () => {
        setAnimationEnded(true);
        onRowAnimationEnd();
    };

    function checkIfUserOwnsAll(lootSequence) {
        if (!lootSequence || lootSequence.length === 0) {
            onSkippableChange(true);
            console.log('No loot sequence found, marking as skippable.');
            return;
        }
        for (const itemId of lootSequence) {
            const item = allItems.find((itm) => itm.itemType === itemId);
            console.log('For item ID:', itemId, ' found item:', item, ' with boolean', (!item || !item.hasUserItem()));
            if (!item || !item.hasUserItem()) {
                onSkippableChange(false);
                return;
            }
        }
        onSkippableChange(true);
    }

    useEffect(() => {
        if (lootboxContent) {
            animationCleanupRef.current = startLootboxAnimation(
                lootboxContent,
                setVisibleItems,
                setHiddenIndices,
                onAnimationEnd
            );
        }

        return () => {
            if (animationCleanupRef.current) {
                animationCleanupRef.current();
            }
        };
    }, [lootboxContent]);

    useEffect(() => {
        if (!lootboxContent) {
            return;
        }
        const visibleItems = lootboxContent.lootSequence.filter(
            (item, index) => !hiddenIndices.includes(index)
        );
        checkIfUserOwnsAll(visibleItems);
    }, [hiddenIndices, lootboxContent]);

    const handleClick = (item, performClick) => {
        if (!performClick) {
            return;
        }
        navigate(`/items-detail/${item}/my-items`);
    };

    return (
        <div className="lootbox-row-container">
            <div className="lootbox-items">
                {visibleItems.map((item, index) => (
                    <span
                        key={index}
                        className={`lootbox-item ${
                            hiddenIndices.includes(index) ? 'hidden' : (animationEnded ? 'finished' : '')
                        }`}
                        onClick={() => handleClick(item, animationEnded)}
                    >
                        <ItemIcon lootItem={item} textSize={2}/>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default LootboxRow;